/**
 * Converts minutes to TimeSpan format (HH:mm:ss)
 * @param minutes - Number of minutes
 * @returns TimeSpan formatted string (HH:mm:ss)
 */
export function minutesToTimeSpan(minutes: number | null | undefined): string | null {
  if (minutes === null || minutes === undefined || isNaN(minutes) || minutes < 0) {
    return null;
  }

  const totalMinutes = Math.floor(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  const secs = 0;

  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

/**
 * Converts TimeSpan format (HH:mm:ss or D.HH:mm:ss) to minutes
 * @param timeSpan - TimeSpan formatted string
 * @returns Number of minutes or null if invalid
 */
export function timeSpanToMinutes(timeSpan: string | null | undefined): number | null {
  if (!timeSpan || typeof timeSpan !== "string") {
    return null;
  }

  const trimmed = timeSpan.trim();
  if (trimmed === "") {
    return null;
  }

  // Handle D.HH:mm:ss format (e.g., "1.02:30:00" = 1 day, 2 hours, 30 minutes)
  const timeSpanRegex = /^(\d+)\.(\d{2}):(\d{2}):(\d{2})$/;
  const timeSpanMatch = trimmed.match(timeSpanRegex);
  if (timeSpanMatch) {
    const days = parseInt(timeSpanMatch[1], 10);
    const hours = parseInt(timeSpanMatch[2], 10);
    const minutes = parseInt(timeSpanMatch[3], 10);
    return days * 24 * 60 + hours * 60 + minutes;
  }

  // Handle HH:mm:ss format (e.g., "02:30:00" = 2 hours, 30 minutes)
  const timeRegex = /^(\d{1,2}):(\d{2}):(\d{2})$/;
  const timeMatch = trimmed.match(timeRegex);
  if (timeMatch) {
    const hours = parseInt(timeMatch[1], 10);
    const minutes = parseInt(timeMatch[2], 10);
    return hours * 60 + minutes;
  }

  // Handle HH:mm format (e.g., "02:30" = 2 hours, 30 minutes)
  const timeShortRegex = /^(\d{1,2}):(\d{2})$/;
  const timeShortMatch = trimmed.match(timeShortRegex);
  if (timeShortMatch) {
    const hours = parseInt(timeShortMatch[1], 10);
    const minutes = parseInt(timeShortMatch[2], 10);
    return hours * 60 + minutes;
  }

  return null;
}

